/* eslint-disable import/prefer-default-export */
export const trimOn = (str, on) => {
	if (str && str.length > on) {
		const arr = str.slice(0, on);
		const name = `${arr}...`;
		return name;
	}
	return str;
};

export const convToId = title => {
	const clean = title
		.replace(/[^\w\s]|_/g, '')
		.replace(/ /g, '-')
		.trim();

	return `scrollid-${clean}`;
};
